import { HelpCircle } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/ui/base/tooltip';

export interface FieldTooltipProps {
  text: string;
}

/** Ícone de ajuda inline para rótulo de campo ou de valor calculado. */
export function FieldTooltip({ text }: FieldTooltipProps) {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button type="button" className="ml-1 inline-flex align-middle" aria-label="Ajuda">
            <HelpCircle className="h-3.5 w-3.5 text-muted-foreground transition-colors hover:text-foreground" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-[250px] text-xs">
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default FieldTooltip;
